// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3P0lc","noInteraction":"EventWrapper_noInteraction__1ez9_","pointerPassthrough":"EventWrapper_pointerPassthrough__2rffi"};